<template>
  <div>
    <div v-if="!loading && record">
      <ui-record-page-item :record="record" />
    </div>
    <div class="" v-else>
      <div class="p-3">
        <div class="flex flex-col gap-4 w-full">
          <div class="skeleton h-10 w-10"></div>
          <div class="skeleton h-4 w-28"></div>
          <div class="skeleton h-4 w-full"></div>
          <div class="skeleton h-4 w-full"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

const { params } = useRoute();
const { getOnpData } = useRecords();

const loading = ref(true);
const record = ref({});

const loadData = async (id) => {
  record.value = await getOnpData(id);
  loading.value = false;
}

watch(() => params.id, async (newId) => {
  await loadData(newId)
}, { immediate: true, deep: true });

onUnmounted(() => {
  loading.value = true;
  record.value = {};
})



</script>